import React, { useState } from 'react';
import WhatsAppCampaigns from '../components/WhatsAppCampaigns';
import MessageTemplatesManager from '../components/MessageTemplatesManager';
import { useBusinessStore } from '../store/useBusinessStore';
import { useAuthStore } from '../store/useAuthStore';
import { Megaphone, MessageSquare, Sparkles } from 'lucide-react';

export default function CampaignsPage() {
  const [activeTab, setActiveTab] = useState('campaigns'); // 'campaigns' | 'templates'
  const { masterDb, activeBusinessId, setMasterDb } = useBusinessStore();
  const { userRole } = useAuthStore();

  const isDemo = ['9001', '9002', '9003'].includes(String(activeBusinessId));
  const isReadOnlyDemo = isDemo && userRole !== 'master';

  const activeBusiness = Array.isArray(masterDb) 
    ? masterDb.find(b => String(b.id) === String(activeBusinessId)) 
    : null;

  if (!activeBusiness) {
    return (
      <div className="p-8 text-center text-seryi-text">
        <p className="animate-pulse text-xs">Cargando módulo de marketing...</p>
      </div>
    );
  }

  const handleUpdateBusiness = (updatedBusiness) => {
    setMasterDb(prev => {
      if (!Array.isArray(prev)) return prev;
      return prev.map(b => {
        if (String(b.id) === String(updatedBusiness.id)) {
          return { ...b, ...updatedBusiness };
        }
        return b;
      });
    });
  };

  return (
    <div className="space-y-6">
      {/* Selector de Pestañas Superior */}
      <div className="flex items-center gap-2 border-b border-seryi-bg-light/60 pb-3">
        <button
          onClick={() => setActiveTab('campaigns')}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-2xl text-xs font-bold transition-all ${
            activeTab === 'campaigns'
              ? 'bg-seryi-green text-seryi-bg-dark shadow-md shadow-seryi-green/20'
              : 'bg-seryi-bg text-seryi-text hover:text-seryi-heading hover:bg-seryi-bg-light'
          }`}
        >
          <Megaphone size={15} />
          <span>Campañas & Difusión Masiva</span>
        </button>

        <button
          onClick={() => setActiveTab('templates')}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-2xl text-xs font-bold transition-all ${
            activeTab === 'templates'
              ? 'bg-seryi-green text-seryi-bg-dark shadow-md shadow-seryi-green/20'
              : 'bg-seryi-bg text-seryi-text hover:text-seryi-heading hover:bg-seryi-bg-light'
          }`}
        >
          <MessageSquare size={15} />
          <span>Editor de Plantillas IA</span>
        </button>
      </div>

      {/* Renderizado de la Pestaña Activa */}
      {activeTab === 'campaigns' ? (
        <WhatsAppCampaigns
          activeBusiness={activeBusiness}
          onUpdateBusiness={handleUpdateBusiness}
          isReadOnlyDemo={isReadOnlyDemo}
        />
      ) : (
        <MessageTemplatesManager
          activeBusiness={activeBusiness}
          onUpdateBusiness={handleUpdateBusiness}
          isReadOnlyDemo={isReadOnlyDemo}
        />
      )}
    </div>
  );
}
